__turbopack_context__.v({
  "downloads": "app-download-links-module-scss-module__wZlAfq__downloads",
});
